export const CLEAN_FORM = 'fuerzaventas/vendedor/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'fuerzaventas/vendedor/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/vendedor/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/vendedor/receive-v-list';
export const REQUEST_V_LIST = 'fuerzaventas/vendedor/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/vendedor/error-v-list';
export const SET_MASK = 'fuerzaventas/vendedor/set-mask';
export const SET_ORDER = 'fuerzaventas/vendedor/set-order';
export const RECEIVE_DATA= 'fuerzaventas/vendedor/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/vendedor/update-table-column';
export const SET_PAGE = 'fuerzaventas/vendedor/set-page';
export const SET_SELECTED_ROW = 'fuerzaventas/vendedor/set-selected-row';